import * as React from 'react';
import { connect } from 'react-redux';
import { DecisionConfig, QueryBuilder } from '../components';
import store from '../store/store';
import types from '../store/types';
import { EModalType, IOutputValue, EOutputLookupContext, OutputsHelper, IBranch, QueryBuilderHelper, ActionHelper } from '../helpers';
import { IDropdownOption } from 'office-ui-fabric-react';
interface IProps {
    branchIndex: number;
    dismissDialog?: () => void;
    componentDialogToggle?: () => void;
    toggleDecisionConfigDialog?: (componentId: string, previousOutputBlocks: any) => void;
}
class DecisionConfigContainer extends React.Component<any, IProps, any> {

    addBranch = () => {
        if (store.getState().modalState.decisionConfig.branchEditIndex === null) {
            let branchTemplate: IBranch = this.props.cache.componentTemplates
                .filter(ct => ct.Decision)[0]
                .Decision.Branches[0];

            store.dispatch({
                type: types.ADD_BRANCH,
                branch: branchTemplate,
                componentId: this.props.state.componentId
            });

        }

    }

    saveEditedBranch = () => {
        store.dispatch({
            type: types.SAVE_EDITED_BRANCH
        });
    }

    updateEditedBranch = (editedBranch: IBranch) => {
        store.dispatch({
            type: types.UPDATE_EDITED_BRANCH,
            editedBranch: editedBranch
        });
    }

    setBranchEditIndex = (branchIndex: number) => {
        store.dispatch({
            type: types.SET_BRANCH_EDIT_INDEX,
            branchIndex: branchIndex
        });
    }

    deleteBranch = (index: number) => {
        store.dispatch({
            type: types.DELETE_BRANCH,
            branchIndex: index,
            componentId: this.props.state.componentId
        });
    }

    closeDialog = (save?: boolean) => {

        // let { state } = store.getState().modalState.decisionConfig;
        let state = store.getState().modalState.decisionConfig;

        if (save) {

            if (QueryBuilderHelper.canSaveQueryEditor()) {

                // if (QueryBuilderHelper.hasOpenQueryEditor()) {
                //     QueryBuilderHelper.goToFirstOpenQueryEditor();
                // }
                // else {
                //find branches that have been removed, and remove all components associated with those branches
                let newStateBranchComponents = {};
                for (let i = 0; i < state.decision.Branches.length; i++) {
                    if (state.decision.Branches[i].NextComponent && state.decision.Branches[i].NextComponent.ComponentId) {
                        newStateBranchComponents[state.decision.Branches[i].NextComponent.ComponentId] = true;
                    }
                }

                let components = store.getState().processState.components;

                let removedBranchComponents: string[] = components[state.componentId].Decision.Branches
                    .filter(c => c.NextComponent && c.NextComponent.ComponentId && !(newStateBranchComponents[c.NextComponent.ComponentId]))
                    .map(c => c.NextComponent.ComponentId);

                for (let i = 0; i < removedBranchComponents.length; i++) {

                    store.dispatch({
                        type: types.DELETE_COMPONENT_CHAIN,
                        componentId: removedBranchComponents[i],
                        components: components
                    });

                }

                // Save the decision
                store.dispatch({
                    type: types.UPDATE_DECISION,
                    componentId: state.componentId,
                    decision: state.decision
                });

                if (removedBranchComponents.length) {
                    store.dispatch({
                        type: types.SET_ACTIVE_COMPONENTS,
                        components: store.getState().processState.components
                    });
                }

                let outputsInUse: {} = OutputsHelper.getLatestOutputsInUse();
                store.dispatch({
                    type: types.UPDATE_OUTPUTS_IN_USE,
                    outputsInUse: outputsInUse
                });

                store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
                // }

            }
            else {
                QueryBuilderHelper.goToFirstQueryEditorError();
            }

        }
        else {
            store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
        }

    }

    public render() {

        let { previousOutputBlocks, decision, branchEditIndex, editedBranch } = this.props.state;
        let { operators, operatorTypes } = this.props.cache;
        let { branchIndex, output, componentId, addOnly, addBranchOnly, dismissDialog, toggleDecisionConfigDialog,
            removeOnly, removeBranchOnly, overviewOnly, conditions, componentDialogToggle } = this.props;
        let outputOptions: IDropdownOption[] = [];

        if (previousOutputBlocks) {
            outputOptions = OutputsHelper.getOutputDropdownOptions(this.props.outputs, previousOutputBlocks);
        }

        return <DecisionConfig
            decision={decision}
            conditions={conditions}
            branchEditIndex={branchEditIndex}
            editedBranch={editedBranch}
            addBranch={this.addBranch}
            closeDialog={this.closeDialog}
            deleteBranch={this.deleteBranch}
            operators={operators}
            operatorTypes={operatorTypes}
            outputOptions={outputOptions}
            saveEditedBranch={this.saveEditedBranch}
            updateEditedBranch={this.updateEditedBranch}
            setBranchEditIndex={this.setBranchEditIndex}
            componentDialogToggle={componentDialogToggle}
            branchIndex={branchIndex}
            componentId={componentId}
            toggleDecisionConfigDialog={toggleDecisionConfigDialog}
            previousOutputBlocks={previousOutputBlocks}
            addOnly={addOnly}
            addBranchOnly={addBranchOnly}
            dismissDialog={dismissDialog}
            removeOnly={removeOnly}
            removeBranchOnly={removeBranchOnly}
            overviewOnly={overviewOnly}
        />;
    }

}

const mapStateToProps = (store) => {

    let outputs: IOutputValue[] = OutputsHelper.combineOutputs(store.outputsState.outputs, store.outputsState.globalOutputs, store.modalState.modal.parentLoopId);

    return {
        state: store.modalState.decisionConfig,
        cache: store.cacheState,
        outputs: outputs
    };

};

export default connect<any, any, any>(mapStateToProps)(DecisionConfigContainer);



// WEBPACK FOOTER //
// ./source/ts/containers/decision-config.tsx